import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
// icons
import { 
  FaUserAlt, 
  FaSignInAlt, 
  FaHeart, 
  FaUserEdit, 
  FaSignOutAlt, 
  FaBookReader, 
  FaShoppingBag 
} from 'react-icons/fa';
// slices
import { userSelector } from 'slices/user';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
// components
import DropMenuLogged from 'components/navbar/DropMenuLogged';

const MyAccount = ({ setShowOffCanvas, closeSession, isDesktop = false, isSticky }) => {
  const { t } = useTranslation(['header']);
  const { isLogged } = useSelector(userSelector);
  const { assignedLibrary } = useAssignedLibrary();

  const getMyAccount = () => (isLogged ?
    isDesktop ? (<div className="header__button--logged">
      <DropMenuLogged
        className="header__button "
        dropDirection="down"
        closeSession={closeSession}
        sticky={isSticky}
      />
    </div>) : (<>
      <Link className="hamb-menu-user" to={`/${assignedLibrary}/perfil`} onClick={() => setShowOffCanvas(false)} >
        <FaUserEdit className="icon-sm fas ham-h i-user" title="Mi Perfil" />
        <span className="simple-hide-mobile">{t("myProfile")}</span>
      </Link>
      <Link className="hamb-menu-user" to={`/${assignedLibrary}/mis-libros`} onClick={() => setShowOffCanvas(false)} >
        <FaBookReader className="icon-sm fas ham-h i-user" title="Mis Libros" />
        <span className="simple-hide-mobile">{t("myBooks")}</span>
      </Link>
      <Link className="hamb-menu-user" to={`/${assignedLibrary}/favoritos`} onClick={() => setShowOffCanvas(false)} >
        <FaHeart className="icon-sm fas ham-h i-user" title="Mis Favoritos" />
        <span className="simple-hide-mobile">{t("misFavoritos")}</span>
      </Link>
      <Link className="hamb-menu-user" to={`/${assignedLibrary}/order-list`} onClick={() => setShowOffCanvas(false)} >
        <FaShoppingBag className="icon-sm fas ham-h i-user" title="Mis Pedidos" />
        <span className="simple-hide-mobile">{t("myOrders")}</span>
      </Link>
      <Link className="hamb-menu-user" onClick={() => closeSession()} to={'/'}>
        <FaSignOutAlt className="icon-sm fas ham-h i-user" title="Cerrar sesión" />
        <span className="simple-hide-mobile">{t("logout")}</span>
      </Link>
    </>) : (<>
      <Link to={`/${assignedLibrary}/registro`}
        className={`${isDesktop ? `navbar-right__link position-relative pt-0 ${isSticky ? 'navbar-item-log' : ''}` : 'hamb-menu-user'}`}
        onClick={() => setShowOffCanvas && setShowOffCanvas(false)}>
        <FaUserAlt className={`${isDesktop ? 'fas i-user' : 'icon-sm fas ham-h sign-in-alt'}`} title="Registro" />
        <span className={`${isDesktop ? `simple-hide-desktop ${isSticky ? 'd-none' : 'd-block'}` : 'simple-hide-mobile'}`}>{t('registro')}</span>
      </Link>
      <Link to={`/${assignedLibrary}/inicio-sesion`}
        className={`${isDesktop ? `navbar-right__link position-relative pt-0 ${isSticky ? 'navbar-item-log' : ''}` : 'hamb-menu-user'}`}
        onClick={() => setShowOffCanvas && setShowOffCanvas(false)}>
        <FaSignInAlt className={`${isDesktop ? 'fas sign-in-alt' : 'icon-sm fas ham-h sign-in-alt'}`} title="Iniciar sesión" />
        <span className={`${isDesktop ? `simple-hide-desktop ${isSticky ? 'd-none' : 'd-block'}` : 'simple-hide-mobile'}`}>{t('iniciarSesion')}</span>
      </Link>
    </>))

  return (
    <>
      {isDesktop ? getMyAccount() : <div className="hamb-menu d-lg-none">
        {/* CONEXION DESDE MENU HAMBURGUESA*/}
        {getMyAccount()}
      </div>}
    </>
  );
};

MyAccount.propTypes = {
  setShowOffCanvas: PropTypes.func,
  closeSession: PropTypes.func,
  isDesktop: PropTypes.bool,
  isSticky: PropTypes.bool
};

export default MyAccount;
